class ReviewsSlider extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      swiperClass: '.swiper'
    }
  }

  connectedCallback() {
    this.initSlider();

    setTimeout(() => {
      this.initSlider();
    }, 1000);
  }

  initSlider() {
    this.slider = this.querySelector(this.selectors.swiperClass) ? this.querySelector(this.selectors.swiperClass) : null;

    this.reviewsSlider = new Swiper(this.slider, {
      slidesPerView: 1.09,
      spaceBetween: 8,
      centeredSlides: true,
      loop: true,
      breakpoints: {
        560: {
          slidesPerView: 1.831,
        },
        769: {
          slidesPerView: 2.331,
        },
        900: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 3.331,
          spaceBetween: 32,
        },
        1500: {
          slidesPerView: 3.9,
          spaceBetween: 32,
        },
        1800: {
          slidesPerView: 4.8,
          spaceBetween: 32,
        },
        2200: {
          slidesPerView: 5.331,
          spaceBetween: 32,
        }
      }
    });
  }
}

customElements.define("reviews-slider", ReviewsSlider);